interface UseAccessControlResult {
    isAllowed: boolean;
    isChecked: boolean;
    isLoading: boolean;
    hasAccessCheckError: boolean;
}

/** Main App access is public. Wallet and transaction requirements are checked by each action. */
export function useAccessControl(): UseAccessControlResult {
    return {
        isAllowed: true,
        isChecked: true,
        isLoading: false,
        hasAccessCheckError: false
    };
}
